// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/buefy.css
// module id = 257
// module chunks = 11